module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/bg-container-yellow-af9a2d135469aebe6cd5b33490b07ba2.png";